import { render } from "./checkproinfo.vue?vue&type=template&id=9f978dd2"
import script from "./checkproinfo.vue?vue&type=script&lang=js"
export * from "./checkproinfo.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\web\\sal_appgd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__